// extracted by mini-css-extract-plugin
module.exports = {"focused":"Navigator_focused__iA_Ir","nav":"Navigator_nav__3EXOl","disabled":"Navigator_disabled__2oiy6"};